<!-- Start of Quick search common component -->
<app-quick-search [DefaultFilterArray]="DefaultFilterArray" [QuickSearchFilterArray]="quickFilterArray"
  (updateDefaultArray)="updateDefaultArray($event)" (clearQuickSearch)="clearQuickSearch($event)">
</app-quick-search>
<!-- End of Quick search common component -->

<!--Filter Code  -->
<div class="col-lg-12 nopadding">
  <app-filter-panel [GridColumns]="GridColumns" [DefaultFilterArray]="DefaultFilterArray"
    (FilterEvent)="FilterApplyFilterEvent($event)" [isDatefilterDropdown]="true">
  </app-filter-panel>
</div>


<!--Grid Code  -->
<div class="col-lg-12 nopadding">
  @if(isLoadingResults){
  <div class="example-loading-shade">
    <mat-spinner></mat-spinner>
  </div>
  }
  <p-table #dt [value]="Dataset" [columns]="cols" [resizableColumns]="true" [lazy]="true" (onPage)="changePage($event)"
    [sortOrder]="constantService.DEFAULT_SORDORDER_ASC" [(selection)]="selectedRow" [paginator]="true"
    selectionMode="single" appendTo="body" alwaysShowPaginator="true" paginatorPosition="both"
    showCurrentPageReport="true" [rows]="constantService.DEFAULT_ROWSIZE" [totalRecords]="totalRecords"
    [pageLinks]="constantService.GRID_DEFAULT_PAGELINKS" sortMode="multiple"
    [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION" [scrollable]="true" scrollHeight="63vh">
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          {{constantService.NO_RECORDFOUND_MSG}}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for(col of columns; track col.field + '-'+ $index) {
        <th id="columns" pResizableColumn [pSortableColumn]="col.field"
          [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
          {{col.header}}
          @if((col.header | lowercase) !== 'action'){
          <p-sortIcon [field]="col.field"></p-sortIcon>
          }
        </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
      <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex"
        [ngClass]="(row['modifiedFlag'] | lowercase)== 'u' ? 'ui-widget-updated-row' : (row['modifiedFlag'] | lowercase) == 'd' ? 'ui-widget-deleted-row .ui-chkbox ' : 'ui-widget-NoUpdated-row'">
        @for(col of columns; track col.field + '-'+ $index) {
        <td class="ui-resizable-column" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
          <!-- set String -->
          @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float' && (col.datatype | lowercase) !='boolean'){
          @if((col.header | lowercase) =='orderid'){
          <span>
            <a class="cat-exception-table-link" matTooltip="View Order Details" [matTooltipShowDelay]="1000"
              appendTo="body" [id]="'OrderID'+ rowIndex" (click)="onViewOrderID(row)"
              style="color: blue;cursor: pointer">{{row[col.field]}}</a>
          </span>
          }@else{
          <span>
            {{row[col.field]}}
          </span>
          }
          }
          <!-- set Boolean -->
          @if((col.datatype | lowercase) =='boolean'){
          <span>
              {{row[col.field] == 1 ? 'true' : 'false'}}
          </span>
          }
          <!-- set int  -->
          @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
          <span style="float:right;">
            {{row[col.field] * 1}}
          </span>
          }
          @if(col.header==='action'){
          <span>
            <p-button [ngStyle]="{width:'23px'}" class="pi pi-xxx" or class="fa fa-xxx" matTooltip="View"
              [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body" icon="fa fa-xxx fa-eye"
              [id]="'view'+ rowIndex" (click)="onView(rowIndex,row)"></p-button>
          </span>
          }
        </td>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorright">
      <app-export-to-csv [gridColumns]="exportGridColumns"
        (exportToCSVListner)="exportToCSV($event)">
      </app-export-to-csv>
      Total Records: {{Dataset.length == 0? 0 : totalRecords}}

    </ng-template>
    <ng-template pTemplate="paginatorleft">
      Showing {{Dataset.length == 0? 0 : startLimit + 1}} to {{Dataset.length
      < rowcount ? Dataset.length < startLimit ? endLimit : Dataset.length : endLimit}} entries </ng-template>
  </p-table>
</div>

<!-- Quick View Panel Code  -->
 @if(isQuickViewOpenClose){
<app-quickview-sidebar [columnJSON]="GridColumns" [selectedData]="selectedRow" [display]="isQuickViewOpenClose" (CloseEvent)="QuickViewCloseEvent($event)">
</app-quickview-sidebar>
 }